/**
 * 浏览器端仅解析 JWT payload（不校验签名），用于本应用 scope 等 UI 门禁。
 * 敏感鉴权须以 msOrg / 各业务后端验签为准。
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const raw = String(token || "").trim();
  if (!raw) return null;
  const parts = raw.split(".");
  if (parts.length < 2) return null;
  let b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
  while (b64.length % 4) b64 += "=";
  try {
    const json = atob(b64);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}
